// Absolute URLs for og:image / twitter:image. Social crawlers require absolute URLs.
// The /__l5e/assets-v1/ paths are served by Lovable's CDN regardless of deployment.
import og1 from "@/assets/og-share-1.jpg.asset.json";
import og2 from "@/assets/og-share-2.jpg.asset.json";
import og3 from "@/assets/og-share-3.jpg.asset.json";
import og4 from "@/assets/og-share-4.jpg.asset.json";
import og5 from "@/assets/og-share-5.jpg.asset.json";
import og6 from "@/assets/og-share-6.jpg.asset.json";
import ogMiniGolf from "@/assets/og-share-mini-golf.jpg.asset.json";

const SITE_ORIGIN = "https://glowlonggolf.com";
const abs = (p: string) => (p.startsWith("http") ? p : `${SITE_ORIGIN}${p}`);

export const SHARE_IMAGES = {
  fairwayArc: abs(og1.url),       // 1 — six glowing balls in an arc on dusk fairway
  cometSwing: abs(og2.url),       // 2 — silhouetted swing with glowing trail
  flatLayGrid: abs(og3.url),      // 3 — overhead grid of glowing balls
  teeOff: abs(og4.url),           // 4 — silhouetted tee-off with glowing teed ball
  macroDew: abs(og5.url),         // 5 — macro of a single glowing ball on dewy grass
  backyardTrails: abs(og6.url),   // 6 — backyard string lights with motion trails
  nightMiniGolf: abs(ogMiniGolf.url), // night mini golf course w/ windmill + glow balls
} as const;

// Home page rotation — varied energy each request.
export const HOME_SHARE_ROTATION = [
  SHARE_IMAGES.fairwayArc,
  SHARE_IMAGES.teeOff,
  SHARE_IMAGES.backyardTrails,
  SHARE_IMAGES.cometSwing,
] as const;

export function pickHomeShareImage(): string {
  const i = Math.floor(Math.random() * HOME_SHARE_ROTATION.length);
  return HOME_SHARE_ROTATION[i];
}
